import React, { useState } from "react";
import BatchCard from "./BatchCard";
import Actions from "./Actions";
import AssignModal from "../AssignModal";
import Loader from "../../../Loader";
import AssignMockInterviewModal from "../AssignMockInterviewModal";

const RightSide = ({
  batchDetails,
  selectedUserIds,
  setCreateBatchFlag,
  setLoading,
  studentsData,
  assignPrepGuideModalFlag: propsAssignPrepGuideModalFlag,
  setAssignPrepGuideModalFlag: propsSetAssignPrepGuideModalFlag,
  assignMockInterviewModalFlag: propsAssignMockInterviewModalFlag,
  setAssignMockInterviewModalFlag: propsSetAssignMockInterviewModalFlag,
}) => {
  const [internalAssignPrepGuideModalFlag, setInternalAssignPrepGuideModalFlag] =
    useState(false);
  const [
    internalAssignMockInterviewModalFlag,
    setInternalAssignMockInterviewModalFlag,
  ] = useState(false);

  const isControlled = propsSetAssignPrepGuideModalFlag !== undefined;

  const assignPrepGuideModalFlag = isControlled
    ? propsAssignPrepGuideModalFlag
    : internalAssignPrepGuideModalFlag;
  const setAssignPrepGuideModalFlag =
    propsSetAssignPrepGuideModalFlag || setInternalAssignPrepGuideModalFlag;

  const assignMockInterviewModalFlag = isControlled
    ? propsAssignMockInterviewModalFlag
    : internalAssignMockInterviewModalFlag;
  const setAssignMockInterviewModalFlag =
    propsSetAssignMockInterviewModalFlag ||
    setInternalAssignMockInterviewModalFlag;

  return (
    <>
      {!isControlled && assignPrepGuideModalFlag && (
        <AssignModal
          selectedUserIds={selectedUserIds}
          setAssignPrepGuideModalFlag={setAssignPrepGuideModalFlag}
          assignPrepGuideModalFlag={assignPrepGuideModalFlag}
          setLoading={setLoading}
          batchDetails={batchDetails}
          studentsData={studentsData}
        />
      )}
      {!isControlled && assignMockInterviewModalFlag && (
        <AssignMockInterviewModal
          assignMockInterviewModalFlag={assignMockInterviewModalFlag}
          setAssignMockInterviewModalFlag={setAssignMockInterviewModalFlag}
          setLoading={setLoading}
          selectedUserIds={selectedUserIds}
          batchDetails={batchDetails}
          studentsData={studentsData}
        />
      )}
      <div className="mt-5 flex flex-col gap-6">
        <BatchCard batchDetails={batchDetails} />
        <Actions
          selectedUserIds={selectedUserIds}
          setAssignPrepGuideModalFlag={setAssignPrepGuideModalFlag}
          setCreateBatchFlag={setCreateBatchFlag}
          setAssignMockInterviewModalFlag={setAssignMockInterviewModalFlag}
          assignMockInterviewModalFlag={assignMockInterviewModalFlag}
        />
      </div>
    </>
  );
};

export default RightSide;
